import React from 'react';
import { random } from 'lodash';
import { useConst } from '@fiverr-private/hooks';
import { Masonry, MasonryCard } from '../Masonry';
import { InnerSkeleton } from '../InnerSkeleton';
import type { InspireGridSkeletonProps } from './types';

export const InspireGridSkeleton = ({ count }: InspireGridSkeletonProps) => {
  return (
    <Masonry>
      {new Array(count).fill(null).map((_, index) => (
        <MasonryCard key={index}>
          <InnerSkeletonWrapper />
        </MasonryCard>
      ))}
    </Masonry>
  );
};

const MIN_HEIGHT = 180;
const MAX_HEIGHT = 420;
const InnerSkeletonWrapper = () => {
  const height = useConst(() => random(MIN_HEIGHT, MAX_HEIGHT));
  return <InnerSkeleton height={height}></InnerSkeleton>;
};
